
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  signal,
} from "@angular/core";
import { Blast, HoleService } from "src/app/services/hole.service";
import { BlastLoadInformationsComponent } from "./blast-load-informations/blast-load-informations.component";
import { BlastLoadDataComponent } from "./blast-load-data/blast-load-data.component";
import { FonctionsService } from "src/app/services/fonctions-partagees.service";
import { UtilisateurService } from "src/app/services/utilisateur.service";
import { SiteHoleTolerance } from "src/app/bo/site-hole-tolerance";

@Component({
  selector: "app-blast-load",
  templateUrl: "./blast-load.component.html",
  styleUrls: ["./blast-load.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BlastLoadInformationsComponent,
    BlastLoadDataComponent
],
})
export class BlastLoadComponent {
  readonly tirId = input.required<number>();

  protected readonly blast = signal<Blast | null>(null);
  protected readonly holeSelected = signal<string | null>(null);
  protected readonly isInformationsCollapsed = signal(false);
  protected readonly qualityData = signal<SiteHoleTolerance | null>(null);

  protected readonly dataComponentClass = computed(() =>
    `col-md-${12 - (this.isInformationsCollapsed() ? 1 : 5)}`
  );

  private loadSeq = 0;

  constructor(
    private readonly holeService: HoleService,
    private readonly fonctionsService: FonctionsService,
    private readonly userService: UtilisateurService
  ) {
    effect(() => {
      const id = this.tirId();
      if (id) this.getBlastHoles(id);
    });

    this.getHoleQuality();
  }

  private getHoleQuality(): void {
    const siteId = this.userService.currentSite()?.siteId;
    if (!siteId) return;
    this.holeService.getSiteHoleTolerance(siteId).subscribe({
      next: (tolerance) => this.qualityData.set(tolerance),
      error: (error) => console.error('Error fetching site hole tolerance', error),
    });
  }

  private getBlastHoles(id: number, policy: "cache-first" | "network-only" = "cache-first"): void {
    const seq = ++this.loadSeq;
    this.fonctionsService.loading_screen(true, 10000);
    this.holeService.GetBlastLoading(id, policy).then((blast: Blast) => {
      if (seq !== this.loadSeq) return;
      this.blast.set(blast);
      this.fonctionsService.loading_screen(false, 10000);
    });
  }

  onAddHole(): void {
    this.getBlastHoles(this.tirId(), "network-only");
  }

  onHoleSelected(event: { holeId: string | null; changeCollapsed: boolean }): void {
    this.holeSelected.set(event.holeId);
    if (event.holeId && event.changeCollapsed) {
      this.isInformationsCollapsed.set(false);
    }
  }

  onCollapseChanged(isCollapsed: boolean): void {
    this.isInformationsCollapsed.set(isCollapsed);
  }
}
